export default __webpack_public_path__ + "static/media/swap.c4e771f7.svg";